import { HTTP } from '../../../http-common';
import { handset } from '../../../models/handset';
import { hardware } from '../../../models/hardware';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '../../../models/httpError';
import { hardwareOrder } from '../../../models/HardwareOrder';
// import { NBNHardware } from '../../../models/NBNHardware';

const state = {
  hardwareOrder: new hardwareOrder(),
  handsets: [new handset()],
  rows: [],
  nbnHardwares: [],
  message: new httpError(),
};

//getters

const getters = {
  getField,
};

//Mutations
const mutations = {
  setHardwareOrder(state, order) {
    if (order === '') state.hardwareOrder = new hardwareOrder();
    else state.hardwareOrder = order;
  },
  setHandset(state, handsets) {
    state.handsets = handsets;
  },
  clearRows(state) {
    // state.rows.length = 0;
    state.rows = [];
  },
  setRows(state, rows) {
    state.rows.length = 0;

    rows.forEach((data) => {
      state.rows.push(data);
    });
  },
  setProgress(state, message) {
    state.message = message;
  },
  setNbnHardwares(state, hardwares) {
    state.nbnHardwares = hardwares;
  },
  addRow(state) {
    state.rows.push(
      new hardware({
        hardwareID: state.rows.length - 1,
        quantity: 1,
        fromIPOrder: false,
        bundleId: 0,
      })
    );
  },
  deleteRowByID(state, hardwareID) {
    let index = state.rows.findIndex((x) => x.hardwareID == hardwareID);
    if (index > -1) {
      state.rows.splice(index, 1);
    }
  },
  REMOVE_FROM_INTERNET(state, index) {
    state.rows.splice(index, 1);
  },
  REDUCE_QUANTITY(state, data) {
    state.rows[data.index].quantity = data.length;
  },
  UPDATE_ROW_FREIGHT(state, data) {
    state.rows.forEach((x) => {
      if (x.handsetID === data[0].handsetID) {
        x.freeTypeNoFreight = data[0].freeTypeNoFreight;
        x.freeTypeWithFreight = data[0].freeTypeWithFreight;
      }
    });
  },
  updateField,
};

//ACTIONS
const actions = {
  deleteHardwareRow({ dispatch, state }, index) {
    dispatch('deleteRow', state.rows[index].hardwareID);
  },
  updateRowFreight({ commit }, data) {
    commit('UPDATE_ROW_FREIGHT', data);
  },
  reset({ commit }) {
    commit('setHardwareOrder', new hardwareOrder());
    commit('clearRows');
    commit('setProgress', new httpError());
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },

  getHandsetsFromIPVoice({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(
        'order/GetHandsetsOffOrder/' + rootState.orders.rows[0].orderID
      );
      response
        .then(async (data) => {
          commit('setRows', data.data);
          resolve(data.data);
        })
        .catch((err) => {
          commit('setRows', [new hardware()]);
          reject(err);
        });
    });
  },
  getHandsetsOnOrder({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(
        'Order/getHardwareOnOrder/' + rootState.orders.rows[0].orderID
      );
      response
        .then(function (data) {
          if (data.status === 200) {
            var resultData = data.data;

            state.rows.forEach((row) => {
              let index = state.rows.findIndex(
                (x) => x.bundleId == row.bundleId
              );
              let internets = rootState.orders.internet.rows.filter(
                (x) => x.bundleId == row.bundleId
              );

              if (internets.length == 0) {
                commit(`REMOVE_FROM_INTERNET`, index);
              } else {
                let hwRowData = {
                  index: index,
                  length: internets.length,
                };
                commit(`REDUCE_QUANTITY`, hwRowData);
              }
            });

            if (resultData.lines.length > 0)
              commit('setRows', resultData.lines);

            if (resultData.summary)
              commit('setHardwareOrder', resultData.summary);

            resolve(resultData);
          } else {
            if (typeof state.rows === 'undefined') {
              commit('setRows', [new hardware()]);
              resolve();
            }
          }
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error:' + err, httpStatus: 200 })
          );
          reject(err);
        });
    });
  },

  getHardware({ commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(
        'Order/getHardwareOrder/' + rootState.orders.rows[0].orderID
      );
      response
        .then(async function (data) {
          var resultData = data.data;
          await dispatch('getHandsetsOnOrder');
          commit('setHardwareOrder', resultData);
          dispatch(
            'setMessage',
            new httpError({ message: 'Hardware Retreived', httpStatus: 200 })
          );
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error:' + err, httpStatus: 200 })
          );
          reject(err);
        });
    });
  },

  getHandsets({ commit, dispatch }, showArchive = true) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(`Order/getHandsets/${showArchive}`, '');
      response
        .then(function (data) {
          var resultData = data.data;
          commit('setHandset', resultData);
          resolve(resultData);
          return;
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error:' + err, httpStatus: 200 })
          );
          reject(err);
        });
    });
  },
  saveHardware({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        'order/CreateHardwareOrder/' + rootState.orders.rows[0].orderID,
        state.hardwareOrder
      );
      response
        .then((data) => {
          if (data.status === 200) {
            commit('setHardwareOrder', data.data);
            commit('orders/setHardware', data.data.hardwareOrderID, {
              root: true,
            });
            dispatch(
              'setMessage',
              new httpError({ message: 'Saved OK', httpStatus: 200 })
            );
          }
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({ message: err.response.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  saveHandsets({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        'order/AddHardwareToOrder/' + state.hardwareOrder.hardwareOrderID,
        state.rows
      );
      response
        .then((data) => {
          if (data.status === 200) {
            commit('clearRows');
            commit('setRows', data.data);
            dispatch(
              'setMessage',
              new httpError({ message: 'Saved OK', httpStatus: 200 })
            );
          }
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({ message: err.response.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  saveDeliveryAddress({commit, dispatch, state}) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        'order/AddDeliveryAddressToOrder/', state.hardwareOrder
      );
      response
        .then((data) => {
          if (data.status == 200) {
            commit('setHardwareOrder', data.data);
            dispatch(
              'setMessage',
              new httpError({ message: 'Delivery address saved', httpStatus: 200 })
            );
          }
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({ message: err.response.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  deleteRow({ commit, rootState }, hardwareID) {
    return new Promise((resolve, reject) => {
      var response = HTTP.delete(
        'order/RemoveHardwareOnOrder/' + rootState.orders.rows[0].orderID,
        { data: [hardwareID] }
      );
      response
        .then((data) => {
          commit('deleteRowByID', hardwareID);
          resolve(data.data);
        })
        .catch((err) => {
          //   commit('setRows', [new hardware()]);
          reject(err);
        });
    });
  },
  getNBNHardwares({ commit, dispatch }, archive = false) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(`NBNHardware/GetNBNHardwares/${archive}`);
      response
        .then(function (data) {
          if (data.status === 200) {
            let resultData = data.data;
            commit('setNbnHardwares', resultData);
            resolve(resultData);
          }
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error:' + err, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
